export default __webpack_public_path__ + "static/media/head03_ja_pc.67f7490b.png";